import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { LANGS } from '../../../shared/constants/lang.constants';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from '../../../shared/services/auth.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { ID_LOGIN_TYPE } from '../../../shared/constants/common.constants';
import { SharedStorageService } from '../../../shared/services/shared-storage.service';
import { STORAGE_KEY } from '../../../shared/constants/store-key.constants';
import { SingleActionDialogComponent } from '../../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MemberInfoResponse, ModifyInfoService } from '../../../shared/services/modify-info.service';
import { HomeRouterDialogComponent } from '../../../shared/components/dialogs/home-router-dialog/home-router-dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { companyNoValidator } from '../../../shared/utils/validator.util';
import { CompanyCodeOnlyDirective } from '../../../directives/company-code-only.directive';
import { VerifyEnterpriseService } from '../../../shared/services/verify-enterprise.service';
import { ApiResponse } from '../../../shared/interfaces/api-response.model';
import { VerifyEnterpriseInfoResponse } from '../../../shared/interfaces/verify-enterprise.model';
import { FormatDateMMDDPipe } from '../../../pipes/format-date-mmdd.pipe';
import { CompanyCodeMappingService } from '../../../shared/services/company-code-mapping.service';
// 引入其他 component
import { TextComponent } from '../../../shared/components/text/text.component';
import { TagComponent } from '../../../shared/components/tag/tag.component';
import { ReportQueryService } from '../../../shared/services/report-query.service';
import { LatestReportRequest } from '../../../shared/interfaces/report-query.model';
import { CreateMemberRequest } from '../../../shared/interfaces/set-password.model';
import { FormatDatePipe2 } from '../../../pipes/format-date.pipe';
import { take } from 'rxjs/operators';
import { SavePhoneDialogService } from '../../../shared/services/save-phone-dialog.service';
/**
 * 首頁組件
 */
@Component({
  selector: 'app-new-member-center-no-data',
  standalone: true,
  imports: [NgIf, TranslatePipe, MatButton, MatDivider, NgOptimizedImage, ReactiveFormsModule, CompanyCodeOnlyDirective ,FormatDateMMDDPipe,TextComponent,TagComponent,FormatDatePipe2],
  templateUrl: './new-memberCenter-no-data.component.html',
  styleUrl: './new-memberCenter-no-data.component.scss',
})
export class NewMemberCenterNoDataComponent implements OnInit {
  protected readonly LANGS = LANGS;
  translateService: TranslateService = inject(TranslateService);
  authService: AuthService = inject(AuthService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  router: Router = inject(Router);
  route: ActivatedRoute = inject(ActivatedRoute);
  modifyInfoService: ModifyInfoService = inject(ModifyInfoService);
  verifyEnterpriseService: VerifyEnterpriseService = inject(VerifyEnterpriseService);
  companyCodeMappingService: CompanyCodeMappingService = inject(CompanyCodeMappingService);
  reportQueryService: ReportQueryService = inject(ReportQueryService);
  savePhoneDialogService: SavePhoneDialogService = inject(SavePhoneDialogService);

  showPageContent: boolean = true;

  // 回到頂部按鈕是否被點擊
  isBackToTopClicked = false;

  // 回到頂部按鈕是否被滑過
  isHovered = false;

  // 預防多次點擊
  isButtonDisabled = false;

  createMemberRequest: CreateMemberRequest | null = null;

  // 使用者於新增手機彈窗點「稍後填寫」時帶入，有值代表尚未綁定手機
  @Input() cellSaveLater: string = '';

  //用來擋有沒有預約過
  flowCode: string = this.sharedStorageService.get('myReservation')?.flowCode ?? '';
  bookStatus: string = this.sharedStorageService.get('myReservation')?.bookStatus ?? '';
  dialog: MatDialog = inject(MatDialog);
  private isFormSubmitted = false;
  enterpriseCodeControl = new FormControl('', [
    Validators.required,
    (control: FormControl) => companyNoValidator(control, this.translateService)
  ]);

  // 檢查是否為 UAT 環境
  isUatEnvironment: boolean = true;

  lastCheckupDate = signal<string>('');

  ngOnInit() {
    console.log('Router URL:', this.router.url);
    this.createMemberRequest = this.sharedStorageService.get('createMemberRequest') || null;
    // 方便測試，清除特殊方案
    this.sharedStorageService.remove('healthPlan');

    // 若是走漸進式登入，則自動填入企業代碼
    const savedCompanyNo = this.sharedStorageService.get('companyNo');
    if (savedCompanyNo) {
      this.enterpriseCodeControl.setValue(savedCompanyNo);
    }
    
    // 檢查環境配置
    const env = (window as any)?.env;
    // this.isUatEnvironment = env?.environment !== 'prod';


    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    // CB-054 取得上次健檢日期
    const request: LatestReportRequest = {
      idNo: this.createMemberRequest?.idNo || '',
    };
    this.reportQueryService.getLatestReport(request)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.lastCheckupDate.set(response.data?.bookDate || '');
          console.log('取得上次健檢日期成功:', response.data?.bookDate);
        },
        error: (error) => {
          console.error('取得上次健檢日期失敗:', error);
          this.lastCheckupDate.set('');
        }
      });
  }

  reservedBlocking(router: string) {
      if(this.flowCode === '4'){
        const completeExamDialog = this.dialog.open(
        SingleActionDialogComponent,
        {
          data: {
                title: this.translateService.instant(
                'id-login.login-already-reserved-dialog.title'
                ),
                buttonText: this.translateService.instant(
                  'common.button.confirm'
                ),
            showCloseButton: true,
            closeAction: () => {
              completeExamDialog.close();
              this.router.navigate(['/']).then();
            },
            action: () => {
              completeExamDialog.close();
              this.router.navigate(['/healthcheck/member/mybooking']).then();
            },
          },
        }
      );
    }else{
      this.router.navigate([router]).then();
    }
  }

  handleEnterpriseClick() {
    // 尚未綁定手機（於彈窗點了稍後填寫）→ 先重開綁定手機彈窗，綁定後再繼續
    if (this.reopenSavePhoneDialogIfLater(() => this.handleEnterpriseClick())) {
      return;
    }
    // 預防多次點擊
    if (this.isButtonDisabled) {
      return;
    }
    this.isFormSubmitted = true;
    
    if (this.enterpriseCodeControl.valid) {
      // 檢查企業代碼格式
      if (this.enterpriseCodeControl.invalid) {
        this.enterpriseCodeControl.markAsTouched();
        return;
      }

      this.isButtonDisabled = true;
      // 設定預約類型為企業
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.ENTERPRISE);
      
      // 轉換網路預約代碼為公司代碼
      const inputCode = this.enterpriseCodeControl.value?.trim() ?? '';
      const companyCode = this.companyCodeMappingService.convertWebCodeToCompanyCode(inputCode);
      
      if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin') {
        if(this.flowCode !== '0'){
          this.isButtonDisabled = false;
          const completeExamDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            data: {
              title: this.translateService.instant(
              'id-login.login-already-reserved-dialog.title'
              ),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                completeExamDialog.close();
                this.router.navigate(['/']).then();
              },
              action: () => {
                completeExamDialog.close();
                this.router.navigate(['/healthcheck/member/mybooking']).then();
              },
            },
          }
        );
        } else {
          // 驗證企業資訊(CB-040) - 已登入
          this.verifyMemberEnterpriseInfo(companyCode);
        }
      } else {
        // 驗證企業資訊(CB-040) - 未登入
        this.verifyNewEnterpriseInfo(companyCode);
      }
    }
  }

  handlePersonalClick() {
    console.log('個人預約被點擊');
    // 尚未綁定手機（於彈窗點了稍後填寫）→ 先重開綁定手機彈窗，綁定後再繼續
    if (this.reopenSavePhoneDialogIfLater(() => this.handlePersonalClick())) {
      return;
    }

    // 檢查環境配置，如果是 prod 環境則導向 not-available 頁面
    // 2026/2/2 打開prod
    // const env = (window as any)?.env;
    // if (env?.environment === 'prod') {
    //   this.router.navigate(['/not-available']).then();
    //   return;
    // }

    // 設定預約類型為個人，Guard 需要此值才能放行
    this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);
    this.sharedStorageService.set('reserveStep', 1);

     if (this.authService.isLogin()) {
      console.log('使用者已登入，檢查預約狀態，flowCode:', this.flowCode);
      if (this.flowCode !== '0') {
        console.log('使用者有預約過，顯示無法預約訊息');
          // 不能預約新健檢
          const completeExamDialog = this.dialog.open(
            SingleActionDialogComponent,
            {
              data: {
                title: this.translateService.instant(
                'id-login.login-already-reserved-dialog.title'
                ),
                buttonText: this.translateService.instant(
                  'common.button.confirm'
                ),
                showCloseButton: false,
                action: () => {
                  completeExamDialog.close();
                },
              },
            }
          );
        }else{
          console.log('導向預約頁面');
          this.router.navigate(['/healthcheck/reserve/location']);
        }
    } else {
      this.router.navigate(['/id-login']).then(res => {});
    }
  }

  // 只有在表單提交後才顯示錯誤
  get hasError(): boolean {
    return this.enterpriseCodeControl.invalid && this.isFormSubmitted;
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^A-Za-z0-9-]/g, '').slice(0, 10); // 改成允許英文、數字和連字號
    
    // 同步更新 FormControl 的值
    if (this.enterpriseCodeControl.value !== sanitizedValue) {
      this.enterpriseCodeControl.setValue(sanitizedValue, { emitEvent: false });
    }
    
    // 清除錯誤狀態
    if (this.hasError) {
      this.isFormSubmitted = false;
    }
    
    // 重新驗證
    this.enterpriseCodeControl.updateValueAndValidity();
  }

  // 驗證企業資訊 (CB-040) - 已登入
  verifyMemberEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(已登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res: ApiResponse<VerifyEnterpriseInfoResponse>) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  closeAction: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                  action: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/companylogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          } 
          // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error: unknown) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
              action: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }

  // 驗證企業資訊 (CB-040) - 未登入
  verifyNewEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(未登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res: ApiResponse<VerifyEnterpriseInfoResponse>) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  action: () => {
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/idlogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            console.log('查無企業資料');
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          } 
          // // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error: unknown) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
              action: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }

  // 查無企業資料
  openNoEnterpriseDialog() {
    const noEnterpriseDialog = this.dialog.open(
      SingleActionDialogComponent,
      {
        disableClose: true,
        data: {
          title: this.translateService.instant(
            'error.company-code-error.error-title'
          ),
          message: this.translateService.instant(
            'error.company-code-error.message'
          ),
          buttonText: this.translateService.instant(
            'common.button.i-understood'
          ),
          showCloseButton: false,
          action: () => {
            this.sharedStorageService.clear();
            this.isButtonDisabled = false;
            noEnterpriseDialog.close();
            return;
          },
        },
      }
    );
  }


  /**
   * 若使用者尚未綁定手機（於彈窗點了「稍後填寫」），再次開啟綁定手機彈窗；
   * 綁定成功後才執行原本要進行的動作。
   * @param onBound 綁定成功後要執行的動作
   * @returns 是否已攔截（true = 已重開綁定彈窗，呼叫端應中止後續流程）
   */
  private reopenSavePhoneDialogIfLater(onBound: () => void): boolean {
    // 若 storage 已有手機號碼（已透過其他入口綁定）→ 清除舊的稍後填寫標記，不再跳彈窗
    if (!this.savePhoneDialogService.isCellUnbound()) {
      this.cellSaveLater = '';
      return false;
    }

    const dialogRef = this.savePhoneDialogService.reopenIfCellSaveLater(
      this.cellSaveLater,
      {
        isCreate: false,
        idNo: this.createMemberRequest?.idNo ?? '',
        chartNo: this.createMemberRequest?.chartNo ?? '',
        hideCancel: true,
      }
    );
    if (!dialogRef) {
      return false;
    }

    dialogRef.afterClosed().subscribe((result: string) => {
      // 更新「稍後填寫」標記
      this.cellSaveLater = result === 'later' ? result : '';
      // 沒完成綁定（沒有結果或再次點稍後填寫）→ 不繼續原動作
      if (!result || result === 'later') {
        return;
      }
      // 綁定成功，更新 sharedStorageService 中的手機號碼
      const memberRequest = this.sharedStorageService.get('createMemberRequest');
      if (memberRequest) {
        memberRequest.cell = result;
        this.sharedStorageService.set('createMemberRequest', memberRequest);
        this.createMemberRequest = memberRequest;
      }
      // 綁定完成後執行原本要進行的動作
      onBound();
    });
    return true;
  }

  goToHealthCheckHistory(){
    // 前往我的健檢檔案
    this.router.navigate(['/healthcheck/member/myprofile']).then();
    
  }
}
